// Initialize Wow
new WOW().init();
 
$(".featured_slider").slick({
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
});

$(".category_sliders").slick({
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
});
